// Modules
import React from 'react';

// Styles
import styles from './Spinner.module.scss';

const Spinner = (props) => {
  const { size = 'lg' } = props;

  return (
    <div className={styles[size]}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default Spinner;
